import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareExecutiveSummaryDocumentInputData,
  PrepareExecutiveSummaryDocumentPublicLinkInputData,
} from "./executiveSummaryFacade";

class ExecutiveSummaryService {
  DoGetExecutiveSummaryDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareExecutiveSummaryDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/ExecutiveSummary/GetExecutiveSummaryDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetExecutiveSummaryDocumentPublicLink(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareExecutiveSummaryDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/ExecutiveSummary/GetExecutiveSummaryDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ExecutiveSummaryService();
